export default __webpack_public_path__ + "e1a8304656f9524304a30f5e2cea5350.svg";